var _path, _rect, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgShoppingBagDiscount = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 18,
  height: 18,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.5,
  d: "m7.688 11.813 2.625-2.626M7.5 9.056a.056.056 0 1 1 0 0zM10.5 11.944a.056.056 0 1 1 0 0z"
})), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  width: 12,
  height: 10.5,
  x: 3,
  y: 5.25,
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.5,
  rx: 2
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.5,
  d: "M6.375 5.25V4.5A2.625 2.625 0 0 1 9 1.875v0A2.625 2.625 0 0 1 11.625 4.5v.75"
})));
export default SvgShoppingBagDiscount;